const common = {
  appLoading: "App Loading...",
  turn_one: 'Turn',
  turn_other: 'Turns',
  contactSupport: 'Contact Support: {contactNumber}', // 1900234534
}

export default common;